export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_802_SCORECARD___SUBTITLE_': 'Scorecard: {{subtitle}}'
};
